import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import commonActions from '../../../redux/Common/actions';
import $ from 'jquery';
import Scrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import MenuLink from '../../common/MenuLink';
import Alert from '../../common/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { MdDashboard, MdMiscellaneousServices } from 'react-icons/md';
import { FaTicketAlt, FaHistory, FaUsersSlash, FaStarHalfAlt } from 'react-icons/fa';
import { TbReport } from 'react-icons/tb';
import { BsHourglassSplit, BsFileEarmarkTextFill } from 'react-icons/bs';
import { useHistory } from 'react-router-dom/esm/react-router-dom';
import Dropdown from '../../common/dropdown';

export default function Sidenavigation() {

    const pathName = useHistory().location.pathname;

    const dispatch = useDispatch();

    const { response, Filtered_Dates } = useSelector(state => state.commonReducer);

    useEffect(() => {
        if (Filtered_Dates?.Page) {
            if ((((Filtered_Dates?.Page && Filtered_Dates?.Page === 'tickets') && (pathName !== '/Manager-Tickets-List' && pathName !== '/Manager-Ticket-Details')) ||
                ((Filtered_Dates?.Page && Filtered_Dates?.Page === 'DO') && (pathName !== '/Manager-Delivery-Orders-List' && pathName !== '/Manager-Delivery-Order-Details')) ||
                ((Filtered_Dates?.Page && Filtered_Dates?.Page === 'CO') && (pathName !== '/Manager-Current-Order-List' && pathName !== '/Manager-Current-Order-Details')) ||
                ((Filtered_Dates?.Page && Filtered_Dates?.Page === 'UT') && (pathName !== '/Manager-Unclosed-Ticket-List' && pathName !== '/Manager-Ticket-Details')))) {
                dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: null, EndDate: null, Page: null } });
            }
        } else {
            dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: null, EndDate: null, Page: null } });
        };
        //eslint-disable-next-line
    }, [Filtered_Dates?.Page, pathName]);

    function removeoverlay() {
        $('.ms-body').toggleClass('ms-aside-left-open');
        $('#ms-side-nav').toggleClass('ms-aside-open');
        $(".ms-aside-overlay.ms-overlay-left").toggleClass('d-block');
    };

    return (
        <>
            <Alert response={response} />
            <div>
                <div className="ms-aside-overlay ms-overlay-left ms-toggler" onClick={removeoverlay}></div>
                <div className="ms-aside-overlay ms-overlay-right ms-toggler"></div>
                <Scrollbar id="ms-side-nav" className="side-nav fixed ms-aside-scrollable ms-aside-left sidenav-background">
                    <div className="logo-sn ms-d-block-lg cakey-logo-backround">
                        <Link className="pl-0 ml-0 text-center" to="/">
                            <img className='cakey-logo' src='https://sugitechnologies.com/images/AppImages/cakeylogo_veylgq.svg' alt="logo" />
                        </Link>
                    </div>
                    <ul className="accordion ms-main-aside fs-14" id="side-nav-accordion">
                        <li className="menu-item">
                            <MenuLink to="/Manager-Dashboard">
                                <MdDashboard className="sidenavigationIcon" /><span className='pl-3'>Dashboard </span>
                            </MenuLink>
                        </li>
                        <Dropdown
                            head={<MenuLink
                                to={pathName === '/Manager-Delivery-Order-Details' || pathName === '/Manager-Current-Order-Details' ||
                                    pathName === '/Manager-Ticket-Details' || pathName === '/Manager-Unclosed-Ticket-Details' ?
                                    '/Manager-Delivery-Orders-List' : '#'}
                                className={pathName === '/Manager-Delivery-Orders-List' || pathName === '/Manager-Current-Order-List' ||
                                    pathName === '/Manager-Delivery-Order-Details' || pathName === '/Manager-Current-Order-Details' ?
                                    "has-chevron active" : "has-chevron"}
                            >
                                <BsFileEarmarkTextFill className="sidenavigationIcon" /><span className='pl-3'>Orders</span>
                            </MenuLink>}
                            body={
                                <ul id="product" className='active' aria-labelledby="product" data-parent="#side-nav-accordion">
                                    <li>
                                        <MenuLink to="/Manager-Delivery-Orders-List" >Orders Based On Delivery Date</MenuLink>
                                    </li>
                                    <li>
                                        <MenuLink to="/Manager-Current-Order-List" >Orders Based On Order Date</MenuLink>
                                    </li>
                                </ul >
                            }
                        />
                        <Dropdown
                            head={<MenuLink
                                to={pathName === '/Manager-Delivery-Order-Details' || pathName === '/Manager-Current-Order-Details' ||
                                    pathName === '/Manager-Ticket-Details' || pathName === '/Manager-Unclosed-Ticket-Details' ?
                                    '/Manager-Tickets-List' : '#'}
                                className={(pathName === '/Manager-Tickets-List' || pathName === '/Manager-Unclosed-Ticket-List' ||
                                    pathName === '/Manager-Ticket-Details' || pathName === '/Manager-Unclosed-Ticket-Details') ?
                                    "has-chevron active" : "has-chevron"}
                            >
                                <FaTicketAlt className="sidenavigationIcon" /><span className='pl-3'>Tickets </span>
                            </MenuLink>}
                            body={
                                <ul id="product" className='active' aria-labelledby="product" data-parent="#side-nav-accordion">
                                    <li>
                                        <MenuLink to="/Manager-Tickets-List" >Tickets</MenuLink>
                                    </li>
                                    <li>
                                        <MenuLink to="/Manager-Unclosed-Ticket-List" >Unclosed Tickets</MenuLink>
                                    </li>
                                    <li>
                                        <MenuLink to="/Manager-All-Tickets-List" >All Tickets List</MenuLink>
                                    </li>
                                </ul >
                            }
                        />
                        <li className="menu-item">
                            <MenuLink to="/Manager-Daily-Tickets-Report">
                                <TbReport className="sidenavigationIcon" /><span className='pl-3'>Daily Reports </span>
                            </MenuLink>
                        </li>
                        <Dropdown
                            head={<MenuLink
                                to={pathName === '/Manager-Delivery-Order-Details' || pathName === '/Manager-Current-Order-Details' ||
                                    pathName === '/Manager-Ticket-Details' || pathName === '/Manager-Unclosed-Ticket-Details' ?
                                    '/Manager-Vendor-Login-History' : '#'}
                                className={(pathName === '/Manager-Vendor-Login-History' || pathName === '/Manager-HelpdeskV-Login-History' ||
                                    pathName === '/Manager-HelpdeskC-Login-History') ?
                                    "has-chevron active" : "has-chevron"}
                            >
                                <FaHistory className="sidenavigationIcon" /><span className='pl-3'>Login History </span>
                            </MenuLink>}
                            body={
                                <ul id="product" className='active' aria-labelledby="product" data-parent="#side-nav-accordion">
                                    <li>
                                        <MenuLink to="/Manager-Vendor-Login-History" >Vendors Login History</MenuLink>
                                    </li>
                                    <li>
                                        <MenuLink to="/Manager-HelpdeskV-Login-History" >Vendor Helpdesk Login History</MenuLink>
                                    </li>
                                    <li>
                                        <MenuLink to="/Manager-HelpdeskC-Login-History" >Customer Helpdesk Login History</MenuLink>
                                    </li>
                                </ul >
                            }
                        />
                        <Dropdown
                            head={<MenuLink
                                to={pathName === '/Manager-Delivery-Order-Details' || pathName === '/Manager-Current-Order-Details' ||
                                    pathName === '/Manager-Ticket-Details' || pathName === '/Manager-Unclosed-Ticket-Details' ?
                                    '/Manager-Vendor-Work-hrs' : '#'}
                                className={(pathName === '/Manager-Vendor-Work-hrs' || pathName === '/Manager-HelpdeskV-Work-hrs' ||
                                    pathName === '/Manager-HelpdeskC-Work-hrs') ?
                                    "has-chevron active" : "has-chevron"}
                            >
                                <BsHourglassSplit className="sidenavigationIcon" /><span className='pl-3'>Work Hours Report </span>
                            </MenuLink>}
                            body={
                                <ul id="product" className='active' aria-labelledby="product" data-parent="#side-nav-accordion">
                                    <li>
                                        <MenuLink to="/Manager-Vendor-Work-hrs" >Vendors Work Hours Report</MenuLink>
                                    </li>
                                    <li>
                                        <MenuLink to="/Manager-HelpdeskV-Work-hrs" >Vendor Helpdesk Work Hours Report</MenuLink>
                                    </li>
                                    <li>
                                        <MenuLink to="/Manager-HelpdeskC-Work-hrs" >Customer Helpdesk Work Hours Report</MenuLink>
                                    </li>
                                </ul >
                            }
                        />
                        <li className="menu-item">
                            <MenuLink to="/Manager-Inactive-Vendors">
                                <FaUsersSlash className="sidenavigationIcon" /><span className='pl-3'>Inactive Vendors </span>
                            </MenuLink>
                        </li>
                        <li className="menu-item">
                            <MenuLink to="/Manager-customer-ratings">
                                <FaStarHalfAlt className="sidenavigationIcon" /><span className='pl-3'>Customer Ratings </span>
                            </MenuLink>
                        </li>
                        <li className="menu-item">
                            <MenuLink to="/Manager-miscellaneous-refund">
                                <MdMiscellaneousServices className="sidenavigationIcon" /><span className='pl-3'>Miscellaneous Refund Report </span>
                            </MenuLink>
                        </li>
                    </ul >
                </Scrollbar>
            </div >
        </>
    );
};